const config = {
  0: {
    btnName: '下一步',
    // eslint-disable-next-line global-require
    src: require('../../imgs/guide1.png'),
    style: {},
  },
  1: {
    btnName: '下一步',
    // eslint-disable-next-line global-require
    src: require('../../imgs/guide2.png'),
    style: {},
  },
  2: {
    btnName: '我知道了',
    // eslint-disable-next-line global-require
    src: require('../../imgs/guide3.png'),
    style: {},
  },
};
export default config;
